import { useScrollIntoView } from '@mantine/hooks'
import HelmetMetaData from 'src/components/HelmetMetaData'
import LandingPageBanner from 'src/components/banners/LandingPageBanner'
import TopSection from './sections/TopSection'
import BuiltForYouSection from './sections/BuiltForYouSection'
import TestimonialSection from './sections/TestimonialSection'
import InteractiveSection from './sections/InteractiveSection'
import ChoosePlanSection from './sections/ChoosePlanSection'

import useFlagAffiliate from './hooks/useFlagAffiliate'

const LandingPage = (props) => {
  // grabbed from the URL from react-router, only if the /join:affiliate route
  const affiliateId = props.match?.params?.affiliate

  // create query params
  const queryParams = new URLSearchParams(window.location.search)
  const affParam = queryParams.get('affiliate')
  const adIdParam = queryParams.get('utm_id')

  // two hooks i made to track affiliate clicks and flagging from the old page
  const { loading, error, affiliate, affiliateVideo, campaign } = useFlagAffiliate(affiliateId || affParam, adIdParam)

  const { targetRef, scrollIntoView } = useScrollIntoView({ offset: affiliate ? 165 : 100 })

  return (
    <div data-cy='landing-page'>
      <HelmetMetaData title='Begin your language journey | From Zero!' />
      <LandingPageBanner affiliate={affiliate} scrollToPlanSelect={scrollIntoView} />
      <TopSection scrollToPlanSelect={scrollIntoView} />
      <BuiltForYouSection />
      <TestimonialSection />
      <InteractiveSection scrollToPlanSelect={scrollIntoView} />
      <ChoosePlanSection ref={targetRef} affiliate={affiliate} />
    </div>
  )
}

export default LandingPage
